import { render, staticRenderFns } from "./QuestionnaireViewQuestion.vue?vue&type=template&id=60fb97b0&"
import script from "./QuestionnaireViewQuestion.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireViewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireViewQuestion.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports